<template>
  <VDialogV3
    id="demand-edit-buyer-info-dialog"
    position="right"
    width="600px"
    height="100vh"
    :loading="false"
    title="Редактирование данных покупателя"
    @submit="onSubmit"
  >
    <section>
      <VSelect
        v-model="localBaseDemand.buyer"
        label="Покупатель"
        required
        disabled
      />

      <VSelectV2
        v-model="localBaseDemand.buyerCompany"
        label="Юр. лицо"
        required
        :data="localBaseDemand.buyer.companies"
      />

      <VSelectV2
        v-model="localBaseDemand.buyerStore"
        label="Склад доставки"
        required
        :data="localBaseDemand.buyer.stores"
      />

      <VSelectV2
        v-model="localBaseDemand.buyerProductionSite"
        label="Производственная площадка"
        :data="productionSiteSource"
      />
    </section>

    <hr>

    <section>
      <VSelect
        v-model="localBaseDemand.responsibleBuyer"
        label="Ответственный"
        layout="vertical"
        required
        :search-function="pattern => PersonsService.searchPersons(pattern, localBaseDemand.buyer.id)"
      />
    </section>

    <hr>

    <div>
      <VHelperText icon="attention">
        Редактирование этих полей изменит данные у всех позиций товаров в потребности.
      </VHelperText>
    </div>
  </VDialogV3>
</template>

<script lang="ts">

import Core                from '@/core/Core';
import PersonsService      from '@/domains/Persons/PersonsService';
import Demand              from '@/domains/Demand/Demand';
import SelectLoader        from '@/lib/components/VSelectV2/SelectLoader';

import type Company        from '@/domains/Companies/Company';
import type ProductionSite from '@/domains/ProductionSites/ProductionSite';

export default defineComponent({
  name: 'DemandBuyerRequisitesDialog',

  props: {
    baseDemand: {
      type:    Object as PropType<Demand>,
      default: null,
    },
  },

  emits: ['close', 'save'],

  data() {
    return {
      PersonsService,

      localBaseDemand: Core.utils.cloneDeep(this.baseDemand) as Demand,
      productionSiteSource: new SelectLoader<ProductionSite>(async ({ company }: { company: Company }) => {
        await company.loadProductionSites();
        return company.productionSites;
      })
        .dependsOn({ company: () => this.localBaseDemand.buyerCompany })
        .preloadOnFocus(),
    };
  },

  methods: {
    /** Применяет изменения (VDialogV3 уже провалидировал форму) и закрывает диалог */
    onSubmit(): void {
      this.$emit('save', this.localBaseDemand);
      this.$core.dialogs.DemandBuyerRequisitesDialog.hide();
    },
  },
});
</script>
